export class DialogDataModel {
  public title: string = null;
  public text: string = null;
}
